import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { VoyadoContactOverview } from '../../core/models/voyado-contact-overview.model';
import { ContactMessages } from '../../core/models/contact-messages.model';
import { ContactTransactions } from '../../core/models/contact-transactions.model';

@Injectable({ providedIn: 'root' })
export class VoyadoCrmService {
    constructor(private httpClient: HttpClient) {}

    getContactOverview(email: string): Observable<VoyadoContactOverview> {
        return this.httpClient.get<VoyadoContactOverview>(environment.apiInboxUrl + 'VoyadoCrm/contacts', {
            params: { email },
        });
    }

    getContactMessages(contactId: number, count: number, skip: number): Observable<ContactMessages> {
        return this.httpClient.get<ContactMessages>(
            environment.apiInboxUrl + 'VoyadoCrm/contacts/' + contactId + '/messages',
            { params: { count, skip } },
        );
    }

    getContactTransactions(contactId: number, count: number, skip: number): Observable<ContactTransactions> {
        return this.httpClient.get<ContactTransactions>(
            environment.apiInboxUrl + 'VoyadoCrm/contacts/' + contactId + '/transactions',
            { params: { count, skip } },
        );
    }
}
